import { IconNode, Typography } from '@components/base';
import { IUSERTYPES } from '@helpers/types/people';
import React, { CSSProperties, useMemo } from 'react';
import css from './index.module.scss';
import { Image } from '@components/base';
import Images from '@assets/images';

interface UserCardProps {
  src?: string;
  userInfo: IUSERTYPES[];
  style?: CSSProperties;
  onDelete?: (userId: string, pocId: string) => void;
  isEditMode?: boolean;
  orderPocId: string;
}

const UserCard = (props: UserCardProps) => {
  const { userInfo, onDelete, isEditMode, orderPocId } = props;
  return (
    <React.Fragment>
      <div className={css.cardsWrapper}>
        {userInfo?.map((user, index) => {
          return (
            <div key={index} className={css.userCardContainer}>
              <Image
                src={user?.profile_image}
                alt={`${user?.given_name} icon`}
                className={css.profileIcon}
                fallbackText={`${user?.given_name[0]?.toLocaleUpperCase() ?? ''}`}
              />
              <div className={css.userCardDetailColumn}>
                <Typography variant="h5" className={css.primaryTitleLabel}>
                  {user?.given_name} {user?.family_name}
                </Typography>
                <Typography variant="p" className={css.secondaryText}>
                  {user?.email}
                </Typography>
              </div>
              {isEditMode && (
                <IconNode
                  src={Images.crossRed}
                  alt="Delete POC"
                  className={css.deleteIcon}
                  onClick={() => onDelete?.(user.user_id, orderPocId)}
                />
              )}
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

export default UserCard;
